<template>
  <v-row>
    <v-col md="2" sm="4" cols="12">
      <indicator-item
        title="Оценка филиала"
        :main-value="indicators.finalRating"
        main-value-color="#6BAD01"
        tooltip-text="Текущий рейтинг филиала и общее кол-во оценок за все время"
        icon="/img/stat/icons/final-rating.svg"
        :loading="loading"
      >
        <template #sub-value>
          <span
            style="font-weight: bold"
          >{{ indicators.totalRatingsCount }} оценок</span>
        </template>
      </indicator-item>
    </v-col>
    <v-col md="2" sm="4" cols="12">
      <indicator-item
        title="Оставили оценку"
        tooltip-text="Кол-во оценок за период и конверсия от запроса отзыва в оценку"
        :main-value="formatCount(indicators.ratingsCount)"
        icon="/img/stat/icons/receipt.svg"
        :loading="loading"
      >
        <template #sub-value>
          <div class="sub-value-label">
            конверсия:
          </div>
          <div class="sub-value-value" style="color: #ff9d00">
            {{ indicators.conversion }}%
          </div>
        </template>
      </indicator-item>
    </v-col>
    <v-col md="2" sm="4" cols="12">
      <indicator-item
        title="Начислено бонусов"
        tooltip-text="Начислено бонусов за период и кол-во бонусов за активные действия"
        :main-value="formatCount(indicators.coins.totalCount)"
        main-value-color="#6BAD01"
        icon="/img/stat/icons/bag.svg"
        :loading="loading"
      >
        <template #sub-value>
          <div class="sub-value-label">
            за действия:
          </div>
          <div class="sub-value-value" style="color: #e92663">
            {{ formatCount(indicators.coins.forActionsCount) }}
          </div>
        </template>
      </indicator-item>
    </v-col>
    <v-col md="2" sm="4" cols="12">
      <indicator-item
        title="Полезных действий"
        tooltip-text="Кол-во действий на внешних источниках"
        :main-value="formatCount(indicators.usefulActionsCount)"
        main-value-color="#6BAD01"
        icon="/img/stat/icons/man.svg"
        :loading="loading"
      >
        <template #sub-value>
          <div class="sub-value-label">
            без действия:
          </div>
          <div class="sub-value-value" style="color: #e92663">
            {{ formatCount(indicators.withoutActionsCount) }}
          </div>
        </template>
      </indicator-item>
    </v-col>
    <v-col md="2" sm="4" cols="12">
      <indicator-item
        title="Лучший рейтинг"
        tooltip-text="Лучший рейтинг за выбранный период"
        :main-value="indicators.bestRating.value"
        icon="/img/stat/icons/best-rating.svg"
        :loading="loading"
      >
        <template #sub-value>
          <div class="sub-value-label">
            дата:
          </div>
          <div class="sub-value-value" style="color: #ff9d00">
            {{ formatDate(indicators.bestRating.date) }}
          </div>
        </template>
      </indicator-item>
    </v-col>
    <v-col md="2" sm="4" cols="12">
      <indicator-item
        title="Худший рейтинг"
        tooltip-text="Худший рейтинг за выбранный период"
        :main-value="indicators.worstRating.value"
        main-value-color="#E92663"
        icon="/img/stat/icons/worst-rating.svg"
        :loading="loading"
      >
        <template #sub-value>
          <div class="sub-value-label">
            дата:
          </div>
          <div class="sub-value-value" style="color: #e92663">
            {{ formatDate(indicators.worstRating.date) }}
          </div>
        </template>
      </indicator-item>
    </v-col>
  </v-row>
</template>

<script>
  import IndicatorItem from '../IndicatorItem.vue'
  import { formatNumberToThousandths } from '@/util/num-format'

  export default {
    name: 'IndicatorsList',
    components: { IndicatorItem },
    props: {
      indicators: {
        type: Object,
        default: () => {},
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      formatCount (value) {
        return formatNumberToThousandths(value)
      },
      formatDate (d) {
        const date = new Date(d)
        const dayOfWeek = date.toLocaleDateString('ru', { weekday: 'short' })
        const formattedDate = date.toLocaleDateString('ru', {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
        })

        return `${dayOfWeek.toUpperCase()} / ${formattedDate}`
      },
    },
  }
</script>

<style lang="less" scoped>
.sub-value-label {
  font-size: 12px;
  color: #949191;
}
.sub-value-value {
  font-size: 12px;
}
</style>
